import React from "react";

// W/D/L form chips — UI-SPEC §1.3 verbatim: W #1F9D55, D #94A3B8, L #E1495C.
// Desktop 20×20 / 10.5px, mobile card variant 14×14 / 8px (K9). NEW shared
// component with the spec's optics — the StandingsWidget's FormDot is a local
// dot-style component and stays untouched (lead consolidates later).
// Exported: THE canonical W/D/L colors (UI-SPEC §1.3) — other form-guide
// surfaces (e.g. the profile rating chart) reuse them instead of hardcoding.
export const FORM_RESULT_COLORS = { W: "#1F9D55", D: "#94A3B8", L: "#E1495C" };
const RES = FORM_RESULT_COLORS;

const FormChips = ({ form, size = 20, fontSize = 10.5, gap = 4 }) => {
  const items = Array.isArray(form)
    ? form
    : typeof form === "string"
      ? form.split("")
      : [];
  const chips = items.filter((r) => RES[r]);
  if (chips.length === 0) return null; // empty renders nothing
  return (
    <span
      className="tp-comp-form"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap,
      }}
    >
      {chips.map((r, i) => (
        <span
          // eslint-disable-next-line react/no-array-index-key
          key={`${r}-${i}`}
          style={{
            width: size,
            height: size,
            borderRadius: 2,
            background: RES[r],
            color: "#fff",
            fontSize,
            fontWeight: 700,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "none",
          }}
        >
          {r}
        </span>
      ))}
    </span>
  );
};

export default FormChips;
